<template>
  <div
    v-if="component && showPaymentTimeout"
    id="timeout-response"
  >
    <b-modal
      v-model="modalVisible"
      hide-header
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="lg"
      static
    >
      <component
        :is="component"
        :debug="debug"
        :elapsed-time="elapsedTime"
        :next-wait-duration="nextWaitDuration"
        @manual-confirm="handleManualConfirm"
        @continue-waiting="handleContinueWaiting"
        @cancel-payment="handleCancelPayment"
      />
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'square-timeout-response-modal',
  props: {
    component: {
      type: Object,
      required: false,
      default: () => null
    },
    debug: {
      type: Boolean,
      required: false,
      default: false
    },
    showPaymentTimeout: {
      type: Boolean,
      required: false,
      default: false
    },
    elapsedTime: {
      type: Number,
      required: false,
      default: 30
    },
    nextWaitDuration: {
      type: Number,
      required: false,
      default: 30
    }
  },
  data: function() {
    return {
      modalVisible: false
    }
  },
  watch: {
    showPaymentTimeout: {
      handler: function(newVal) {
        this.modalVisible = newVal
      },
      immediate: true
    }
  },
  methods: {
    handleManualConfirm() {
      this.$emit('manual-confirm')
    },
    handleContinueWaiting(data) {
      this.$emit('continue-waiting', data)
    },
    handleCancelPayment() {
      this.$emit('cancel-payment')
    }
  }
}
</script>

<style>

</style>
